<template>
  <div>
    <a-table :scroll="{ x: 1800 }" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" :loading="loading" row-key="id" :row-selection="rowSelection" @change="handleTableChange">
      <template slot="action" slot-scope="text, record">
        <a-dropdown placement="bottomCenter">
          <a-icon type="more" />
          <a-menu slot="overlay">
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onEdit(record)">编辑问题</a>
            </a-menu-item>
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onDelete(record.id)">删除问题</a>
            </a-menu-item>
            <a-menu-item v-if="record.is_fault">
              <a class="ant-dropdown-link" @click="onViewFault(record)">查看故障</a>
            </a-menu-item>
            <a-menu-item v-else>
              <a class="ant-dropdown-link" @click="onToFault(record)">转为故障</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
      <template slot="customKey" slot-scope="text, record">
        <div v-if="record.is_fault" class="corner" @click="onViewFault(record)" />
        <span>PB-{{ record.id }}</span>
      </template>
      <template slot="urgency" slot-scope="text, record">
        <problem-urgency-edit :source-id="record.id" :source-value="record.urgency" />
      </template>
      <template slot="problemTitle" slot-scope="text, record">
        <problem-title-edit :source-id="record.id" :source-value="record.title" />
      </template>
      <template slot="tag" slot-scope="text, record">
        <a-popover v-if="record.tags" title="问题标签" placement="topLeft">
          <template slot="content">
            <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
          </template>
          <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
        </a-popover>
        <span v-else>--</span>
      </template>
      <template slot="status" slot-scope="text, record">
        <problem-status-edit :source-id="record.id" :source-value="record.status" :status-flow="record.status_flow" @change="$emit('reload')" />
      </template>
      <template slot="handler" slot-scope="text, record">
        <problem-user-edit :source-id="record.id" :source-value="record.handler" item="handler" />
      </template>
      <template slot="reporter" slot-scope="text, record">
        <problem-user-edit :source-id="record.id" :source-value="record.reporter" item="reporter" />
      </template>
      <template slot="reportedTime" slot-scope="text, record">
        <problem-time-edit :source-id="record.id" item="reported_time" :source-value="record.reported_time" />
      </template>
      <template slot="startedTime" slot-scope="text, record">
        <problem-time-edit :source-id="record.id" item="started_time" :source-value="record.started_time" />
      </template>
      <template slot="resolvedTime" slot-scope="text, record">
        <problem-time-edit :source-id="record.id" item="resolved_time" :source-value="record.resolved_time" />
      </template>
      <template slot="discoveredTime" slot-scope="text, record">
        <problem-time-edit :source-id="record.id" item="discovered_time" :source-value="record.discovered_time" />
      </template>
      <template slot="locatedTime" slot-scope="text, record">
        <problem-time-edit :source-id="record.id" item="located_time" :source-value="record.located_time" />
      </template>
      <template slot="confirmedTime" slot-scope="text, record">
        <problem-time-edit :source-id="record.id" item="confirmed_time" :source-value="record.confirmed_time" />
      </template>
    </a-table>
  </div>
</template>

<script>
import { problemDelete } from '@/api/event/problem';

import ProblemTimeEdit from '@/pages/event/components/ProblemTimeEdit';
import ProblemUserEdit from '@/pages/event/components/ProblemUserEdit';
import ProblemTitleEdit from '@/pages/event/components/ProblemTitleEdit';
import ProblemStatusEdit from '@/pages/event/components/ProblemStatusEdit';
import ProblemUrgencyEdit from '@/pages/event/components/ProblemUrgencyEdit';

const columns = [
  {
    width: 20,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 70,
    scopedSlots: { customRender: 'customKey' }
  },
  {
    title: '标题',
    width: 400,
    ellipsis: true,
    scopedSlots: { customRender: 'problemTitle' }
  },
  {
    title: '状态',
    width: 100,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '紧急程度',
    width: 80,
    scopedSlots: { customRender: 'urgency' }
  },
  {
    title: '处理人',
    width: 100,
    scopedSlots: { customRender: 'handler' }
  },
  {
    title: '反馈人',
    width: 100,
    scopedSlots: { customRender: 'reporter' }
  },
  {
    width: 172,
    title: '上报时间',
    scopedSlots: { customRender: 'reportedTime' }
  },
  {
    width: 172,
    title: '开始时间',
    scopedSlots: { customRender: 'startedTime' }
  },
  {
    width: 172,
    title: '解决时间',
    scopedSlots: { customRender: 'resolvedTime' }
  },
  {
    width: 172,
    title: '发现时间',
    scopedSlots: { customRender: 'discoveredTime' }
  },
  {
    width: 172,
    title: '定位时间',
    scopedSlots: { customRender: 'locatedTime' }
  },
  {
    width: 172,
    title: '业务确认时间',
    scopedSlots: { customRender: 'confirmedTime' }
  },
  {
    title: '关联项目',
    dataIndex: 'projects',
    key: 'projects',
    width: 200,
    ellipsis: true,
    customRender: text => (text ? text.map(item => item.name).join('; ') : '--')
  },
  {
    title: '创建时间',
    width: 164,
    dataIndex: 'created_time',
    key: 'created_time',
    customRender: text => text || '--'
  }
];

export default {
  name: 'ProblemDataList',
  components: {
    ProblemStatusEdit,
    ProblemUserEdit,
    ProblemUrgencyEdit,
    ProblemTitleEdit,
    ProblemTimeEdit
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      columns,
      selectedRowKeys: []
    };
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: selectedRowKeys => {
          this.selectedRowKeys = selectedRowKeys;
          this.$emit('selection-change', selectedRowKeys);
        }
      };
    }
  },
  methods: {
    handleTableChange(pagination) {
      this.$emit('page-change', pagination);
    },
    onEdit(record) {
      this.$emit('edit', record);
    },
    onDelete(id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该问题吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          problemDelete({ id: id }).then(() => {
            self.$message.success('删除成功');
            self.$emit('reload');
          });
        }
      });
    },
    onViewFault(record) {
      this.$router.push({
        name: 'page:event:fault:detail',
        query: {
          faultId: record.id
        }
      });
    },
    onToFault(record) {
      this.$emit('to-fault', record);
    }
  }
};
</script>

<style lang="less" scoped>
.corner {
  position: relative;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}

.corner::before {
  position: absolute;
  top: -12px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: 'RCA';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}

.corner::after {
  position: absolute;
  content: '';
  clip-path: polygon(0 0, 4px 0, 4px 4px);
  width: 8px;
  height: 8px;
  left: -8px;
  bottom: -12px;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  background-color: inherit;
}
</style>
